export const OPT_IN_APP_NOTIF_ID = "opt-in-app-notification";
export const OPT_IN_SMS_ID = "opt-in-sms";
